import { Record } from 'immutable';
const Sender = Record({
  avatar: null,
  email: null,
  firstName: null,
  id: null,
  lastName: null,
  senderType: null,
  isActive: null,
  isAuthorized: null
}, 'Sender');
export default Sender;